import { Box, CircularProgress, CircularProgressProps, Typography } from "@mui/material";
import React from "react";

export const CircularProgressWithLabel = React.forwardRef<
  HTMLDivElement, 
  CircularProgressProps & { value: number }
>((props, ref) => {
  return (
    <Box ref={ref} sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.secondary' }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
});